export function getObjectIdKey(arrayOfEntities) {
  let object = {}
  arrayOfEntities.forEach((entity) => {
    object[entity.id] = entity
    object[entity["@id"]] = entity
  })
  return object
}
